import { render, staticRenderFns } from "./ListaRiesgos.vue?vue&type=template&id=d016985a"
import script from "./ListaRiesgos.vue?vue&type=script&lang=js"
export * from "./ListaRiesgos.vue?vue&type=script&lang=js"
import style0 from "./ListaRiesgos.vue?vue&type=style&index=0&id=d016985a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports